import numberFormats from "@/assets/lang/currencies.json";
import enAU from "@/assets/lang/en-AU.json";
import enGB from "@/assets/lang/en-GB.json";
import enUS from "@/assets/lang/en-US.json";
import enZA from "@/assets/lang/en-ZA.json";
import { createI18n } from "vue-i18n";

type MessageSchema = typeof enGB;

type NumberSchema = {
  currency: {
    style: "currency";
    currencyDisplay: "symbol";
    currency: string;
  };
};

type LangTypes = "en-AU" | "en-GB" | "en-ZA" | "en-US";

export const defaultLocale = "en-GB";

export const i18n = createI18n<
  {
    message: MessageSchema;
    number: NumberSchema;
  },
  LangTypes
>({
  legacy: false, // you must set `false`, to use Composition API
  locale: defaultLocale,
  messages: {
    "en-AU": enAU,
    "en-GB": enGB,
    "en-ZA": enZA,
    "en-US": enUS,
  },
  numberFormats: <Record<LangTypes, NumberSchema>>numberFormats,
});
